module.exports = __webpack_public_path__ + "static/goldivox-5098757708e8741f46439208242a56bf.png";